import { render, staticRenderFns } from "./SafetyCheckBasicInfo.vue?vue&type=template&id=496846cc&scoped=true"
import script from "./SafetyCheckBasicInfo.vue?vue&type=script&lang=js"
export * from "./SafetyCheckBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496846cc",
  null
  
)

export default component.exports